import CheckCircleIcon from '@material-ui/icons/CheckCircleOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { colors } from '@material-ui/core';

export const anchorToast = {
  vertical: 'top',
  horizontal: 'center'
};

export const toastTypes = {
  success: {
    type: 'success',
    defaultMessage: 'La aplicación se actualizó con éxito',
    Icon: CheckCircleIcon,
    backgroundcolor: colors.green[600]
  },
  error: {
    type: 'error',
    defaultMessage: '¡Algo salió mal!',
    Icon: ErrorOutlineOutlinedIcon,
    backgroundcolor: colors.red[600]
  },
  warning: {
    type: 'warning',
    defaultMessage: '',
    Icon: ReportProblemOutlinedIcon,
    backgroundcolor: colors.orange[600]
  }
};
